import { WTableHolder } from '../viewer/page';
/**
 * @private
 */
export class ModifiedLevel {
    constructor(owner, modified) {
        this.ownerListLevelIn = undefined;
        this.modifiedListLevelIn = undefined;
        this.ownerListLevel = owner;
        this.modifiedListLevel = modified;
    }
    get ownerListLevel() {
        return this.ownerListLevelIn;
    }
    set ownerListLevel(value) {
        this.ownerListLevelIn = value;
    }
    get modifiedListLevel() {
        return this.modifiedListLevelIn;
    }
    set modifiedListLevel(value) {
        this.modifiedListLevelIn = value;
    }
    destroy() {
        this.ownerListLevel = undefined;
        this.modifiedListLevel = undefined;
    }
}
/**
 * @private
 */
export class ModifiedParagraphFormat {
    constructor(ownerFormat, modifiedFormat) {
        this.ownerFormatIn = undefined;
        this.modifiedFormatIn = undefined;
        this.ownerFormat = ownerFormat;
        this.modifiedFormat = modifiedFormat;
    }
    get ownerFormat() {
        return this.ownerFormatIn;
    }
    set ownerFormat(value) {
        this.ownerFormatIn = value;
    }
    get modifiedFormat() {
        return this.modifiedFormatIn;
    }
    set modifiedFormat(value) {
        this.modifiedFormatIn = value;
    }
    destroy() {
        if (this.modifiedFormat) {
            this.modifiedFormat.destroy();
        }
        this.modifiedFormat = undefined;
        this.ownerFormat = undefined;
    }
}
/**
 * @private
 */
export class RowHistoryFormat {
    constructor(table, startingPoint, rowFormat, owner) {
        this.startingPoint = startingPoint;
        this.rowFormat = rowFormat;
        this.rowHeightType = rowFormat.heightType;
        this.originalHeight = rowFormat.height;
        this.tableHierarchicalIndex = owner.selectionModule.getHierarchicalIndex(table, '0');
    }
    revertChanges(isRedo, owner, table) {
        //backup current format values.
        const currentRowHeightType = this.rowFormat.heightType;
        //Restore old values.
        const row = table.childWidgets[this.rowFormat.ownerBase.index];
        const targetHeight = isRedo ? this.finalHeight : this.originalHeight;
        row.rowFormat.height = targetHeight;
        owner.documentHelper.layout.reLayoutTable(table);
        if (this.rowFormat.heightType !== this.rowHeightType) {
            this.rowFormat.heightType = this.rowHeightType;
        }
        //backup the current format values for redo.
        this.rowHeightType = currentRowHeightType;
    }
}
/**
 * @private
 */
export class TableHistoryInfo {
    constructor(table, owner) {
        this.tableHolder = new WTableHolder();
        this.tableFormat = new TableFormatHistoryInfo();
        this.rows = [];
        this.owner = owner;
        this.copyProperties(table);
    }
    copyProperties(table) {
        if (table.tableHolder) {
            this.tableHolder = table.tableHolder.clone();
        }
        if (table.tableFormat) {
            this.tableFormat.leftIndent = table.tableFormat.leftIndent;
            this.tableFormat.preferredWidth = table.tableFormat.preferredWidth;
            this.tableFormat.preferredWidthType = table.tableFormat.preferredWidthType;
            this.tableFormat.allowAutoFit = table.tableFormat.allowAutoFit;
        }
        for (let i = 0; i < table.childWidgets.length; i++) {
            const row = table.childWidgets[parseInt(i.toString(), 10)];
            const rowFormat = new RowFormatHistoryInfo();
            rowFormat.gridBefore = row.rowFormat.gridBefore;
            rowFormat.gridBeforeWidth = row.rowFormat.gridBeforeWidth;
            rowFormat.gridBeforeWidthType = row.rowFormat.gridBeforeWidthType;
            rowFormat.gridAfter = row.rowFormat.gridAfter;
            rowFormat.gridAfterWidth = row.rowFormat.gridAfterWidth;
            rowFormat.gridAfterWidthType = row.rowFormat.gridAfterWidthType;
            for (let j = 0; j < row.childWidgets.length; j++) {
                const cell = row.childWidgets[parseInt(j.toString(), 10)];
                const cellFormat = new CellFormatHistoryInfo();
                cellFormat.columnIndex = cell.columnIndex;
                cellFormat.columnSpan = cell.cellFormat.columnSpan;
                cellFormat.preferredWidth = cell.cellFormat.preferredWidth;
                cellFormat.preferredWidthType = cell.cellFormat.preferredWidthType;
                rowFormat.cells.push(cellFormat);
            }
            this.rows.push(rowFormat);
        }
        this.tableHierarchicalIndex = this.owner.selectionModule.getHierarchicalIndex(table, '0');
    }
    destroy() {
        this.tableHierarchicalIndex = undefined;
        if (this.tableHolder) {
            this.tableHolder.destroy();
            this.tableHolder = undefined;
        }
        if (this.tableFormat) {
            this.tableFormat = null;
        }
        if (this.rows) {
            this.rows = [];
            this.rows = undefined;
        }
    }
}
/**
 * @private
 */
export class TableFormatHistoryInfo {
}
/**
 * @private
 */
export class RowFormatHistoryInfo {
    constructor() {
        this.cells = [];
    }
}
/**
 * @private
 */
export class CellFormatHistoryInfo {
}
/**
 * @private
 */
export class CellHistoryFormat {
    constructor(point) {
        this.startingPoint = point; // starting point preserved to calculate the displacement on after cell resizing finished.
    }
}
